import type { FC } from "react";

export const DepositIcon: FC<{ className?: string }> = (props) => (
  <svg
    aria-hidden="true"
    width="32"
    height="25"
    viewBox="0 0 32 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.6739 3.14111H2.68383C2.09582 3.14111 1.61914 3.61663 1.61914 4.20321V22.3164C1.61914 22.903 2.09582 23.3785 2.68383 23.3785H28.6739C29.2619 23.3785 29.7386 22.903 29.7386 22.3164V4.20321C29.7386 3.61663 29.2619 3.14111 28.6739 3.14111Z"
      stroke="#010101"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M1.61914 9.98291H12.1092C12.4064 9.98291 12.6498 10.2258 12.6498 10.5222V15.9973C12.6498 16.2937 12.4064 16.5366 12.1092 16.5366H1.61914V9.98291Z"
      stroke="#010101"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.74604 14.7541C9.57337 14.7541 10.244 14.085 10.244 13.2597C10.244 12.4344 9.57337 11.7654 8.74604 11.7654C7.91872 11.7654 7.24805 12.4344 7.24805 13.2597C7.24805 14.085 7.91872 14.7541 8.74604 14.7541Z"
      fill="#010101"
    />
    <path d="M32 0H20V12H32V0Z" fill="white" />
    <path
      d="M27.0781 1.375C27.0781 4.1455 27.0823 6.91188 27.0864 9.68238"
      stroke="#AE9003"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M22.918 5.5284C25.6952 5.5284 28.4684 5.52445 31.2457 5.52051"
      stroke="#AE9003"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const WithdrawIcon: FC<{ className?: string }> = (props) => (
  <svg
    aria-hidden="true"
    width="31"
    height="25"
    viewBox="0 0 31 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.1376 3.03003H2.06795C1.47814 3.03003 1 3.50817 1 4.09798V22.3112C1 22.901 1.47814 23.3791 2.06795 23.3791H28.1376C28.7274 23.3791 29.2056 22.901 29.2056 22.3112V4.09798C29.2056 3.50817 28.7274 3.03003 28.1376 3.03003Z"
      stroke="#010101"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M1 9.90942H11.5222C11.8203 9.90942 12.0645 10.1536 12.0645 10.4517V15.957C12.0645 16.2551 11.8203 16.4993 11.5222 16.4993H1V9.90942Z"
      stroke="#010101"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.1481 14.7071C8.97795 14.7071 9.65068 14.0343 9.65068 13.2045C9.65068 12.3746 8.97795 11.7019 8.1481 11.7019C7.31824 11.7019 6.64551 12.3746 6.64551 13.2045C6.64551 14.0343 7.31824 14.7071 8.1481 14.7071Z"
      fill="#010101"
    />
    <path d="M30 0H18V12H30V0Z" fill="white" />
    <path
      d="M25.5713 1.68066C25.5713 4.46645 25.5754 7.2481 25.5796 10.0339"
      stroke="#AE9003"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M21.9619 4.82238L25.5425 1.10938L29.2555 4.68992"
      stroke="#AE9003"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const BankIcon: FC<{ className?: string }> = (props) => (
  <svg
    aria-hidden="true"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 13H6V21H4C3.73478 21 3.48043 21.1053 3.29289 21.2929C3.10536 21.4804 3 21.7348 3 22C3 22.2652 3.10536 22.5196 3.29289 22.7071C3.48043 22.8946 3.73478 23 4 23H28C28.2652 23 28.5196 22.8946 28.7071 22.7071C28.8946 22.5196 29 22.2652 29 22C29 21.7348 28.8946 21.4804 28.7071 21.2929C28.5196 21.1053 28.2652 21 28 21H26V13H29C29.2176 12.9998 29.4292 12.9286 29.6026 12.7973C29.7761 12.6659 29.902 12.4816 29.9612 12.2722C30.0205 12.0629 30.0098 11.8399 29.9308 11.6371C29.8519 11.4344 29.709 11.2629 29.5238 11.1487L16.5238 3.14874C16.3662 3.05189 16.1849 3.00061 16 3.00061C15.8151 3.00061 15.6338 3.05189 15.4762 3.14874L2.47625 11.1487C2.29103 11.2629 2.14811 11.4344 2.06916 11.6371C1.99021 11.8399 1.97955 12.0629 2.03878 12.2722C2.09801 12.4816 2.22391 12.6659 2.39738 12.7973C2.57085 12.9286 2.78242 12.9998 3 13ZM8 13H12V21H8V13ZM18 13V21H14V13H18ZM24 21H20V13H24V21ZM16 5.17374L25.4675 11H6.5325L16 5.17374ZM31 26C31 26.2652 30.8946 26.5196 30.7071 26.7071C30.5196 26.8946 30.2652 27 30 27H2C1.73478 27 1.48043 26.8946 1.29289 26.7071C1.10536 26.5196 1 26.2652 1 26C1 25.7348 1.10536 25.4804 1.29289 25.2929C1.48043 25.1053 1.73478 25 2 25H30C30.2652 25 30.5196 25.1053 30.7071 25.2929C30.8946 25.4804 31 25.7348 31 26Z"
      fill="#3F3F46"
    />
  </svg>
);
